var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarFilter = function SvgCarFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5.834 15.167h3.5m-7-4.667 2.333 1.167L6.149 7.22c.306-.918.46-1.377.743-1.717.25-.3.572-.531.936-.674.412-.162.895-.162 1.863-.162h8.618c.968 0 1.452 0 1.863.162.364.143.686.375.936.674.284.34.437.799.743 1.717l1.483 4.447 2.333-1.167m-7 4.667h3.5m-14.234-3.5h12.134c1.96 0 2.94 0 3.689.382.658.335 1.194.87 1.53 1.529.38.749.38 1.729.38 3.689v3.15c0 .542 0 .813-.044 1.039a2.33 2.33 0 0 1-1.833 1.833c-.226.045-.497.045-1.039.045h-.583A2.333 2.333 0 0 1 19.833 21a.583.583 0 0 0-.583-.583H8.75a.583.583 0 0 0-.583.583 2.333 2.333 0 0 1-2.333 2.334H5.25c-.542 0-.813 0-1.038-.045a2.33 2.33 0 0 1-1.834-1.833c-.045-.226-.045-.497-.045-1.039v-3.15c0-1.96 0-2.94.382-3.689a3.5 3.5 0 0 1 1.53-1.53c.748-.381 1.728-.381 3.689-.381"
  })));
};
export default SvgCarFilter;